<template>
  <div style="list-style-type: none;">
    <b-dropdown-item href="#" @click="confirmAction('pivot')"><svg  xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><path d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2m0 12v-5m3 5v-1m3 1v-3"/></g></svg> Exibir Relatório</b-dropdown-item>
    <dashboard-menu :onlyDash="false" :hasIcon="false" :requestId="this.feature.sourceLayer"></dashboard-menu>
  </div>
</template>

<script>
import Vue from 'vue'
import DashboardMenu from '../../legend/DashboardMenu.vue'
Vue.component("DashboardMenu", DashboardMenu); // Registra globalmente

export default {
  props: {
    feature: Object
  },
  data() {
    return {
      selectedOption: "info",
      options: {
        dashboards:[
          {name: 'Avaliação de Área', url: ''},
        ]
      }
    };
  },
  methods: {
    confirmAction(type) {
      let layerId = this.feature.id
      let requestId = this.feature.sourceLayer
      this.$bus.$emit('showTablePivotLegend', {'requestId':requestId,"layerId":layerId, "type": type, 'mapFeature':true})
    }
  }
};
</script>

<style scoped>
.divSelect {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background 0.2s ease-in-out;
}
.divSelect:hover {
    background: #d9d9d9;
}
</style>
